import type { ApiContext } from "@/api/types";
import { httpPublic2 } from "@/api/public";
import type { PolicyMetaData, PracticeNameResponse, UUID } from "@/core/types";

export const publicRequestsTyped = {
  get_policy_metadata: function (): Promise<PolicyMetaData> {
    return httpPublic2.get("/v1/public/get_policy_metadata").json<PolicyMetaData>();
  },
  get_practice_name: function ({
    context,
    practiceId,
  }: {
    context?: ApiContext;
    practiceId: UUID;
  }): Promise<PracticeNameResponse> {
    return httpPublic2
      .post("/v1/a5_screening/get_practice_name", {
        context,
        searchParams: { practiceId },
      })
      .json<PracticeNameResponse>();
  },
};
